"use client";

import { ChevronDown } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { useState } from "react";
import tab1 from "@/assets/home/tab1.png";
import tab2 from "@/assets/home/tab2.png";
import tab3 from "@/assets/home/tab3.png";
import tab4 from "@/assets/home/tab4.png";
import { GameIcon } from "@/components/images/game-icon";
import { Button } from "@/components/ui/button";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { nationwideGame } from "@/utils/nationwide";

export function Menu() {
  const pathname = usePathname();

  return (
    <div className="grid flex-1 grid-cols-6 gap-2 text-xl">
      <Link
        href="/"
        data-active={pathname === "/"}
        className="flex h-16 items-center justify-center border-transparent border-b-2 hover:border-primary hover:text-primary data-[active=true]:border-primary data-[active=true]:text-primary"
      >
        首页
      </Link>
      <MenuLobby />
      <Menu168 />
      <MenuPK10 />
      <MenuMarkSix />
      <Link
        href="/longDragon"
        data-active={pathname === "/longDragon"}
        className="flex h-16 items-center justify-center border-transparent border-b-2 hover:border-primary hover:text-primary data-[active=true]:border-primary data-[active=true]:text-primary"
      >
        长龙提醒
      </Link>
    </div>
  );
}

function getLinkInfo({
  gameType,
  roomId,
}: {
  gameType: string;
  roomId: string;
}) {
  let name = "";

  const searchParams = new URLSearchParams();
  searchParams.set("gameType", gameType);
  searchParams.set("roomId", roomId);
  const href = `/result?${searchParams.toString()}`;
  switch (gameType) {
    case "1070": {
      switch (roomId) {
        case "100002": {
          name = "香港六合彩";
          break;
        }
        case "100005": {
          name = "澳门六合彩";
          break;
        }
        case "91001": {
          name = "台湾六合彩";
          break;
        }
        default:
          return null;
      }
      break;
    }
    case "1062": {
      switch (roomId) {
        case "60301": {
          name = "台湾分分弹珠";
          break;
        }
        case "60303": {
          name = "北京分分弹珠";
          break;
        }
        case "60304": {
          name = "澳门三分弹珠";
          break;
        }
        case "60305": {
          name = "香港五分弹珠";
          break;
        }
        case "60201": {
          name = "澳洲分分弹珠";
          break;
        }
        case "90001": {
          name = "168极速飞艇";
          break;
        }
        case "90002": {
          name = "168幸运飞艇";
          break;
        }
        case "90003": {
          name = "168北京赛车";
          break;
        }
        case "123458": {
          name = "极速赛车";
          break;
        }
        case "123473": {
          name = "秒速赛车";
          break;
        }
        case "123475": {
          name = "700K极速飞艇";
          break;
        }
        case "123461": {
          name = "澳洲幸运10";
          break;
        }
        case "123457": {
          name = "幸运飞艇";
          break;
        }
        default:
          return null;
      }
      break;
    }
    case "1063": {
      switch (roomId) {
        case "90101": {
          name = "168时时彩";
          break;
        }
        case "123474": {
          name = "秒速时时彩";
          break;
        }
        case "123463": {
          name = "澳洲幸运5";
          break;
        }
        case "123460": {
          name = "极速时时彩";
          break;
        }
        default:
          return null;
      }
      break;
    }
    case "1069": {
      switch (roomId) {
        case "90201": {
          name = "168幸运28";
          break;
        }
        case "90202": {
          name = "168pc蛋蛋";
          break;
        }
        default:
          return null;
      }
      break;
    }
    case "1068": {
      switch (roomId) {
        case "90301": {
          name = "168快三";
          break;
        }
        default:
          return null;
      }
      break;
    }
    case "10010":
    case "10011":
    case "10012": {
      const found = nationwideGame.find(
        (item) => item.gameType === gameType && item.roomId === roomId,
      );
      if (!found) {
        return null;
      }
      name = found.name;
      break;
    }
    default:
      return null;
  }
  return { href, name };
}

function MenuLobby() {
  const [open, setOpen] = useState(false);
  return (
    <HoverCard open={open} onOpenChange={setOpen}>
      <HoverCardTrigger className="flex h-16 items-center justify-center border-transparent border-b-2 hover:border-primary hover:text-primary data-[active=true]:border-primary data-[active=true]:text-primary">
        彩票大厅
        <ChevronDown className="size-6" />
      </HoverCardTrigger>
      <HoverCardContent sideOffset={-4} className="w-fit">
        <div className="flex flex-col gap-6 p-4">
          <div className="flex gap-2">
            <div className="flex items-start gap-2">
              <Image src={tab1} alt="tab1" width={24} height={24} />
              <span className="w-16 font-bold">168系列</span>
            </div>
            <div className="grid flex-1 grid-cols-4 gap-2">
              <GameLink
                gameType="1062"
                roomId="90001"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1062"
                roomId="90002"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1062"
                roomId="90003"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1063"
                roomId="90101"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1069"
                roomId="90201"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1069"
                roomId="90202"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1068"
                roomId="90301"
                handleClick={() => setOpen(false)}
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="flex items-start gap-2">
              <Image src={tab2} alt="tab2" width={24} height={24} />
              <span className="w-16 font-bold">弹珠系列</span>
            </div>
            <div className="grid flex-1 grid-cols-4 gap-2">
              <GameLink
                gameType="1062"
                roomId="60301"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1062"
                roomId="60303"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1062"
                roomId="60304"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1062"
                roomId="60305"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1062"
                roomId="60201"
                handleClick={() => setOpen(false)}
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="flex items-start gap-2">
              <Image src={tab3} alt="tab3" width={24} height={24} />
              <span className="w-16 font-bold">六合彩</span>
            </div>
            <div className="grid flex-1 grid-cols-4 gap-2">
              <GameLink
                gameType="1070"
                roomId="100002"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1070"
                roomId="100005"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1070"
                roomId="91001"
                handleClick={() => setOpen(false)}
              />
            </div>
          </div>

          <div className="flex gap-2">
            <div className="flex items-start gap-2">
              <Image src={tab2} alt="tab2" width={24} height={24} />
              <span className="w-16 font-bold">其他游戏</span>
            </div>
            <div className="grid flex-1 grid-cols-4 gap-2">
              <GameLink
                gameType="1062"
                roomId="123458"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1062"
                roomId="123473"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1062"
                roomId="123475"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1063"
                roomId="123474"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1062"
                roomId="123461"
                handleClick={() => setOpen(false)}
              />
              <GameLink
                gameType="1063"
                roomId="123463"
                handleClick={() => setOpen(false)}
              />
              {/* <GameLink
                gameType="1062"
                roomId="123457"
                handleClick={() => setOpen(false)}
              /> */}
              <GameLink
                gameType="1063"
                roomId="123460"
                handleClick={() => setOpen(false)}
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="flex items-start gap-2">
              <Image src={tab4} alt="tab4" width={24} height={24} />
              <span className="w-16 font-bold">全国低频</span>
            </div>
            <div className="grid flex-1 grid-cols-4 gap-2">
              {nationwideGame.map((item) => {
                return (
                  <GameLink
                    key={`${item.gameType}-${item.roomId}`}
                    gameType={item.gameType}
                    roomId={item.roomId}
                    handleClick={() => setOpen(false)}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}

function Menu168() {
  const searchParams = useSearchParams();
  const roomId = searchParams.get("roomId");

  const [open, setOpen] = useState(false);
  return (
    <HoverCard open={open} onOpenChange={setOpen}>
      <HoverCardTrigger
        data-active={[
          "90001",
          "90002",
          "90003",
          "90101",
          "90201",
          "90202",
          "90301",
        ].includes(roomId)}
        className="flex h-16 items-center justify-center border-transparent border-b-2 hover:border-primary hover:text-primary data-[active=true]:border-primary data-[active=true]:text-primary"
      >
        168系列
        <ChevronDown className="size-6" />
      </HoverCardTrigger>
      <HoverCardContent sideOffset={-4} className="w-fit">
        <div className="flex flex-col">
          <MenuItem
            gameType="1062"
            roomId="90001"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1062"
            roomId="90002"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1062"
            roomId="90003"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1063"
            roomId="90101"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1069"
            roomId="90201"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1069"
            roomId="90202"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1068"
            roomId="90301"
            handleClick={() => setOpen(false)}
          />
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}

function MenuMarkSix() {
  const searchParams = useSearchParams();
  const roomId = searchParams.get("roomId");
  const [open, setOpen] = useState(false);
  return (
    <HoverCard open={open} onOpenChange={setOpen}>
      <HoverCardTrigger
        data-active={["100002", "100005"].includes(roomId)}
        className="flex h-16 items-center justify-center border-transparent border-b-2 hover:border-primary hover:text-primary data-[active=true]:border-primary data-[active=true]:text-primary"
      >
        六合彩
        <ChevronDown className="size-6" />
      </HoverCardTrigger>
      <HoverCardContent sideOffset={-4} className="w-fit">
        <div className="flex flex-col">
          <MenuItem
            gameType="1070"
            roomId="100002"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1070"
            roomId="100005"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1070"
            roomId="91001"
            handleClick={() => setOpen(false)}
          />
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}

function MenuPK10() {
  const searchParams = useSearchParams();
  const roomId = searchParams.get("roomId");
  const [open, setOpen] = useState(false);
  return (
    <HoverCard open={open} onOpenChange={setOpen}>
      <HoverCardTrigger
        data-active={["60301", "60303", "60304", "60305", "60201"].includes(
          roomId,
        )}
        className="flex h-16 items-center justify-center border-transparent border-b-2 hover:border-primary hover:text-primary data-[active=true]:border-primary data-[active=true]:text-primary"
      >
        弹珠系列
        <ChevronDown className="size-6" />
      </HoverCardTrigger>
      <HoverCardContent sideOffset={-4} className="w-fit">
        <div className="flex flex-col">
          <MenuItem
            gameType="1062"
            roomId="60305"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1062"
            roomId="60304"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1062"
            roomId="60301"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1062"
            roomId="60303"
            handleClick={() => setOpen(false)}
          />
          <MenuItem
            gameType="1062"
            roomId="60201"
            handleClick={() => setOpen(false)}
          />
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}

function MenuItem({
  gameType,
  roomId,
  handleClick,
}: {
  gameType: string;
  roomId: string;
  handleClick: () => void;
}) {
  const { href, name } = getLinkInfo({ gameType, roomId });
  return (
    <Button variant="ghost" asChild className="h-14 justify-start text-lg">
      <Link href={href} onClick={handleClick}>
        <GameIcon roomId={roomId} width={40} height={40} />
        {name}
      </Link>
    </Button>
  );
}

function GameLink({
  gameType,
  roomId,
  handleClick,
}: {
  gameType: string;
  roomId: string;
  handleClick: () => void;
}) {
  const { href, name } = getLinkInfo({ gameType, roomId });
  return (
    <Link
      href={href}
      className="border-l px-2 hover:text-primary"
      onClick={handleClick}
    >
      {name}
    </Link>
  );
}
